import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import EntityModel from '@/common/models/entity-model';
import {DisplayChoiceModel} from '@/common/models/rules/actions/display-other-choices-action-model';
import parseNumerical from '@/common/helpers/parse-numerical';

export class BumpOfferModel extends EntityModel {
    hydrate({
        bumpAmount = null,
        bonusAmount = null,
        weight = 100,
        name = 'Version 1',
        choices = [],
    } = {}) {
        this.bumpAmount = bumpAmount;
        this.bonusAmount = bonusAmount;
        this.weight = parseNumerical(weight);
        this.name = name;
        this.choices = choices.length
            ? choices.map(v => new DisplayChoiceModel(v))
            : DisplayChoiceModel.getDefaultChoices();
    }

    getPayload() {
        return {
            bumpAmount: parseNumerical(this.bumpAmount),
            bonusAmount: parseNumerical(this.bonusAmount),
            weight: parseNumerical(this.weight),
            name: this.name,
            choices: this.choices.map(v => v.getPayload()),
        };
    }
}

export default class OfferPurchaseBumpActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({bumpOffers: this.bumpOffers = []} = fields);
        this.bumpOffers = this.bumpOffers.length
            ? this.bumpOffers.map(v => new BumpOfferModel(v))
            : [new BumpOfferModel({})];
    }

    getCopyBumpOfferName(name = null) {
        if (name) {
            let newName = name;
            const copies = newName.match(/copy \((.*?)\)/);
            if (copies) {
                newName = newName.substring(0, copies.index).trimEnd();
            }

            let copyCount = this.bumpOffers.filter(offer => offer.name.match(new RegExp(`^${newName}`))).length;
            // eslint-disable-next-line no-loop-func
            while (this.bumpOffers.find(offer => offer.name === `${newName} copy (${copyCount})`)) {
                copyCount += 1;
            }
            return `${newName} copy (${copyCount})`;
        }
        return name;
    }

    recalculateWeights() {
        const bumpOffersTotal = this.bumpOffers.length;
        this.bumpOffers = this.bumpOffers.map(offer => new BumpOfferModel({
            ...offer,
            weight: Math.round((1 / bumpOffersTotal) * 100),
        }));
    }

    getPayload() {
        return {
            ...super.getPayload(),
            bumpOffers: this.bumpOffers.map(v => v.getPayload()),
        };
    }
}
